import { useContext, useMemo } from 'react';
import {
  TEDEKBokforderSTATUSEnum,
  TEDEKBokforderTYPEnum,
  TEDEKBokforderU_UTBETALNINGSKATEGORIEnum,
} from '../../../../../../globalQueryTypes';
import { AvenyContext } from '../../../../../AvenyContext';
import {
  defaultEditMenuSaveButton,
  IEditMenuAction,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import { getFormUpdateValue } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { mergeBusinessDataMutations } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/MergeBusinessDataMutations';
import {
  isSaveButtonDisabled,
  getValuesForNewBokforder,
  getRowsDeleteObjects,
} from '../Utils/BokforderUtils';

export const useBokforderEditMenuSaveButton = (
  bokfgruppId: string | undefined,
  bokforderStatus: TEDEKBokforderSTATUSEnum | undefined,
  isNew: boolean | undefined,
  type: TEDEKBokforderTYPEnum,
  queriesLoading: boolean,
  userID: string | null,
  setEditMessageID: React.Dispatch<React.SetStateAction<string>>,
  utbetalningsKategori: TEDEKBokforderU_UTBETALNINGSKATEGORIEnum | null
): IEditMenuAction => {
  const avenyContext = useContext(AvenyContext);
  const openChoiceCallback = avenyContext.openChoiceCallback;
  const setOpenChoiceDialog = avenyContext.setOpenChoiceDialog;

  return useMemo(
    () => ({
      ...defaultEditMenuSaveButton,
      flat: true,
      isDisabled: params =>
        queriesLoading || isSaveButtonDisabled(params, bokforderStatus),
      label:
        bokforderStatus === TEDEKBokforderSTATUSEnum.UTKAST || isNew
          ? 'Spara Utkast'
          : 'Spara',
      shortLabel: 'Spara',
      onClick: ({ businessDataFormContext, editMenuOnCancel: stopLoading }) => {
        setEditMessageID('');
        if (isNew) {
          const newValues = getValuesForNewBokforder(
            TEDEKBokforderSTATUSEnum.UTKAST,
            bokfgruppId,
            userID,
            utbetalningsKategori,
            false,
            type
          );

          let updateValues = getRowsDeleteObjects(
            businessDataFormContext.formState.currentValues,
            false,
            true
          );

          updateValues = updateValues.concat(newValues);

          const mergedValues = mergeBusinessDataMutations(
            businessDataFormContext.formState.values ?? {},
            getFormUpdateValue(updateValues, businessDataFormContext.data ?? {})
          );
          businessDataFormContext.saveForm(
            mergedValues,
            () => {
              if (avenyContext.openChoiceDialog) {
                setOpenChoiceDialog(false);
                openChoiceCallback?.();
                stopLoading?.();
              } else {
                businessDataFormContext.formStateDispatch({
                  type: 'VALIDATE',
                });
              }
            },
            () => {
              if (avenyContext.openChoiceDialog) {
                stopLoading?.();
              }
            }
          );
        } else {
          let updateValues = getRowsDeleteObjects(
            businessDataFormContext.formState.currentValues,
            false,
            true
          );

          const mergedValues = mergeBusinessDataMutations(
            businessDataFormContext.formState.values ?? {},
            getFormUpdateValue(updateValues, businessDataFormContext.data ?? {})
          );
          businessDataFormContext.saveForm(
            mergedValues,
            () => {
              if (avenyContext.openChoiceDialog) {
                setOpenChoiceDialog(false);
                openChoiceCallback?.();
                stopLoading?.();
              } else {
                businessDataFormContext.formStateDispatch({
                  type: 'VALIDATE',
                });
              }
            },
            () => {
              if (avenyContext.openChoiceDialog) {
                stopLoading?.();
              }
            }
          );
        }
      },
    }),
    [
      openChoiceCallback,
      avenyContext.openChoiceDialog,
      setOpenChoiceDialog,
      bokfgruppId,
      bokforderStatus,
      isNew,
      type,
      queriesLoading,
      userID,
      utbetalningsKategori,
      setEditMessageID,
    ]
  );
};
